
import React from 'react';
// NavLink 
import { NavLink } from 'react-router-dom';
import CardWrapper from './CardWrapper'; // Import CardWrapper for styling


// Create a Dashboard component for the home page
const Dashboard = () => {
  const clients = [
    { id: 'example', name: 'John Smith', program: 'Strength Training', nextSession: 'Tomorrow, 10:00 AM' },
    { id: 'client2', name: 'Sarah Johnson', program: 'Weight Loss', nextSession: 'Today, 5:30 PM' },
    { id: 'client3', name: 'Michael Brown', program: 'Bodybuilding', nextSession: 'Wednesday, 7:00 AM' },
    { id: 'client4', name: 'Emma Wilson', program: 'Rehabilitation', nextSession: 'Friday, 3:00 PM' },
  ];

  const recentActivities = [
    { id: 1, client: 'John Smith', activity: 'Completed workout session', time: '2 hours ago' },
    { id: 2, client: 'Sarah Johnson', activity: 'Updated weight metrics', time: 'Yesterday' },
    { id: 3, client: 'Michael Brown', activity: 'Canceled next session', time: 'Yesterday' },
    { id: 4, client: 'Emma Wilson', activity: 'Achieved strength goal', time: '3 days ago' },
    { id: 5, client: 'John Smith', activity: 'Added new exercise notes', time: '5 days ago' },
  ];

  return (
    <div className="dashboard">
      {/* <h1>Trainer Dashboard</h1> */}

      <CardWrapper>
        <h1>Trainer Dashboard</h1>
      </CardWrapper>
      
      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>Active Clients</h3>
          <p className="stat-number">12</p>
        </div>
        <div className="stat-card">
          <h3>Sessions This Week</h3>
          <p className="stat-number">28</p>
        </div>
        <div className="stat-card">
          <h3>Upcoming Sessions</h3>
          <p className="stat-number">6</p>
        </div>
        <div className="stat-card">
          <h3>Client Goals Achieved</h3>
          <p className="stat-number">15</p>
        </div>
      </div>
      
      <div className="dashboard-section">
        <h2>Your Clients</h2>
        <div className="clients-list">
          {clients.map(client => (
            <div key={client.id} className="client-card ptc-card">
              <div className="client-avatar">
                {client.name.charAt(0)}
              </div>
              <div className="client-info">
                <h3>{client.name}</h3>
                <p>Program: {client.program}</p>
                <p>Next Session: {client.nextSession}</p>
              </div>
              <div className="client-actions">
                <NavLink to={`/clients/${client.id}/dashboard`} className="view-client-btn">
                  View Client
                </NavLink>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="dashboard-section">
        <h2>Recent Activity</h2>
        <div className="activity-feed">
          {recentActivities.map(activity => (
            <div key={activity.id} className="activity-item">
              <div className="activity-icon"></div>
              <div className="activity-details">
                <p><strong>{activity.client}</strong> {activity.activity}</p>
                <p className="activity-time">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export default Dashboard;